import Layout from "./components/Layout/Layout";
import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import PassedTickets from "./components/Reports/PassedTickets";
import ActiveTickets from "./components/Reports/ActiveTickets";
import NonactiveTickets from "./components/Reports/NonactiveTickets";
import NonactiveAndExpiredTickets from "./components/Reports/NonactiveAndExpiredTickets";
import SoldTickets from "./components/Reports/SoldTickets";
import MyIssuedTickets from "./components/Reports/MyIssuedTickets";
import ReportSelection from "./components/ReportSelection/ReportSelection";
import Period from "./components/Period/Period";
import TypeTickets from "./components/Reports/TypeTickets";
import CategoryTickets from "./components/Reports/CategoryTickets";
import KindTickets from "./components/Reports/KindTickets";
import LogCardTickets from "./components/Reports/LogCardTickets";
import Login from "./components/Login/Login";
import Home from "./components/Home/Home";
import PaymentMethod from "./components/Reports/PaymentMethod";
import NewReader from "./components/NewReader/NewReader";
import NewAppUser from "./components/NewAppUser/NewAppUser";
import Monitoring from "./components/Monitoring/Monitoring";
import DailyReport from "./components/Reports/DailyReport";
import PerTicketNumber from "./components/Search/PerTicketNumber";
import PerRegistrationPlate from "./components/Search/PerRegistrationPlate";
import Unauthorized from "./components/Error/Unauthorized";
import PrivatesRoutes from "./components/PrivateRoute/PrivatesRoutes";
import { PERMISSIONS } from "./constants/const";
import AccessRights from "./components/Authorization/AccessRights";
import AdminPasswordReset from "./components/AdminPasswordReset/AdminPasswordReset";
import SuccPassedTickets from "./components/Reports/SuccPassedTickets";
import TopSuccPassedTickets from "./components/Reports/TopSuccPassed";

import ReadersList from "./components/List/ReadersList";
import EditReader from "./components/EDIT/EditReader";
import EditTicket from "./components/EDIT/EditTicket";
import EditTicketByPlate from "./components/EDIT/EditTicketByPlate.jsx";
import PriceList from "./components/PriceList/PriceList";
import EditItem from "./components/EDIT/EditItem";
import NewItem from "./components/PriceList/NewItem";
import NewTicket from "./components/NewTicket/NewTicket";
import QRGenerateTicket from "./components/NewTicket/QRGenerateTicket";
import ResendMail from "./components/NewTicket/ResendMail";

import ChangePassword from "./components/EditProfile/ChangePassword";
import NewKind from "./components/PriceList/NewKind";
import NewCategory from "./components/PriceList/NewCategory";
import NewType from "./components/PriceList/NewType";
import SearchUsers from "./components/Search/SearchUsers";
import Purchasing from "./components/Purchasing/Purchasing";
import Settings from "./components/Settings/Settings";
import UpdateDatabase from "./components/UpdateDatabase/UpdateDatabase";
import TicketDesign from "./components/TicketDesigne/TicketDesign";
import TemplateGroups from "./components/TemplateGroups/TemplateGroups";
import TemplateGroupEvents from "./components/TemplateGroupEvents/TemplateGroupEvents";
import TicketTemplates from "./components/TicketTemplates/TicketTemplates";
import TemplateManagement from "./components/TemplateManagement/TemplateManagement";
import HIK from "./components/HIK/HIK";
import Logs from "./components/Logs/Logs";
import Refund from "./components/Refund/Refund";
import FiscalizationReports from "./components/FiscalizationReports/FiscalizationReports";

import NewEmployee from "./components/NewEmployee/NewEmployee";
import Employees from "./components/List/Employees";
import EditEmployee from "./components/EDIT/EditEmployee";
import NewOrganizationUnit from "./components/NewOrganizationUnit/NewOrganizationUnit";
import OrganizationUnits from "./components/List/OrganizationUnits";
import EditOrganizationalUnit from "./components/EDIT/EditOrganizationalUnit";
import NewArticle from "./components/NewArticle/NewArticle";
import EditArticle from "./components/EDIT/EditArticle";
import Articles from "./components/List/Articles";
import NewUnitOfMeasure from "./components/NewUnitOfMeasure/NewUnitOfMeasure";
import UnitsOfMeasure from "./components/List/UnitsOfMeasure";
import EditUnitOfMeasure from "./components/EDIT/EditUnitOfMeasure";
import NewIngredient from "./components/NewIngredient/NewIngredient";
import Ingredients from "./components/List/Ingredients";
import EditIngredient from "./components/EDIT/EditIngredient";
import { getCameraMode, getMode } from "./api/axios.js";
import DailyArticles from "./components/Reports/DailyArticle.jsx";
import LockerArangment from "./components/LockerArangment/LockerArangment.jsx";
import Lockers from "./components/Lockers/Lockers.jsx";
import LockersMonitoring from "./components/LockersMonitoring/LockersMonitoring.jsx";
import BackupManager from "./components/BackupManager/BackupManager.jsx";
import CameraMonitor from "./components/CameraMonitor/CameraMonitor.jsx";
function App() {
  const [mode, setMode] = useState("");
  const [cameraMode, setCameraMode] = useState("");
  useEffect(() => {
    const fetchMode = async () => {
      const res = await getMode();
      const camRes = await getCameraMode();
      setMode(res);
      setCameraMode(camRes);
    };
    fetchMode();
  }, []);
  return (
    <Routes>
      <Route path="/monitor" element={<Monitoring />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<Layout />}>
        <Route index element={<ReportSelection />} />
        <Route element={<PrivatesRoutes permission={PERMISSIONS.VIEW_HOME} />}>
          <Route path="home" element={<Home />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_ACTIVE} />}
        >
          <Route path="active" element={<ActiveTickets />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_PASSED} />}
        >
          <Route path="passed" element={<PassedTickets />} />
          <Route path="succ_passed" element={<SuccPassedTickets />} />
          <Route path="top_succ_passed" element={<TopSuccPassedTickets />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_NONACTIVE} />}
        >
          <Route path="nonactive" element={<NonactiveTickets />} />
          <Route path="nonactive-and-expired-tickets" element={<NonactiveAndExpiredTickets />} />
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.VIEW_SOLD} />}>
          <Route path="sold" element={<SoldTickets />} />
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.VIEW_HOME} />}>
          <Route path="my-issued-tickets" element={<MyIssuedTickets />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_CATEGORY} />}
        >
          <Route path="category" element={<CategoryTickets />} />
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.VIEW_TYPE} />}>
          <Route path="type" element={<TypeTickets />} />
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.VIEW_KIND} />}>
          <Route path="kind" element={<KindTickets />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_LOG_CARD} />}
        >
          <Route path="log_card" element={<LogCardTickets />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.VIEW_PAYMENT_METHOD} />
          }
        >
          <Route path="payment_method" element={<PaymentMethod />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_MONITORING} />}
        >
          <Route path="monitoring" element={<Monitoring />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_READER} />
          }
        >
          <Route path="new-reader" element={<NewReader />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_TICKET} />
          }
        >
          <Route path="new-ticket" element={<NewTicket />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_TICKET} />
          }
        >
          <Route path="new-paper-ticket" element={<QRGenerateTicket />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_TICKET} />
          }
        >
          <Route path="resend-mail" element={<ResendMail />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_USER} />}
        >
          <Route path="new-user" element={<NewAppUser />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_DAILYREP} />}
        >
          <Route path="dailyrep" element={<DailyReport />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_TICKET_INFO} />}
        >
          <Route path="ticket-info/:ticket_id" element={<PerTicketNumber />} />
        </Route>

        {mode == "1" ? (
          <>
            <Route
              element={
                <PrivatesRoutes permission={PERMISSIONS.VIEW_TEMPLATE_GROUPS} />
              }
            >
              <Route path="template-groups" element={<TemplateGroups />} />
            </Route>
            <Route
              element={
                <PrivatesRoutes
                  permission={PERMISSIONS.VIEW_TEMPLATE_GROUP_EVENTS}
                />
              }
            >
              <Route
                path="template-group-events"
                element={<TemplateGroupEvents />}
              />
            </Route>
          </>
        ) : (
          ""
        )}
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.VIEW_TICKET_TEMPLATES} />
          }
        >
          <Route path="ticket-templates" element={<TicketTemplates />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_PERIOD} />}
        >
          <Route path="period" element={<Period />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.MANAGE_TEMPLATES} />}
        >
          <Route path="template-management" element={<TemplateManagement />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.ADMIN_RESET_PASSWORD} />
          }
        >
          <Route path="admin-reset-password" element={<AdminPasswordReset />} />
        </Route>
        {cameraMode == "1" ? (
          <>
            <Route
              element={
                <PrivatesRoutes permission={PERMISSIONS.VIEW_TICKET_INFO} />
              }
            >
              <Route
                path="plates-info/:registration_plates"
                element={<PerRegistrationPlate />}
              />
            </Route>
            <Route
              element={<PrivatesRoutes permission={PERMISSIONS.EDIT_TICKET} />}
            >
              <Route
                path="plate-ticket/edit/:registration_plates"
                element={<EditTicketByPlate />}
              />
            </Route>

            <Route element={<PrivatesRoutes permission={PERMISSIONS.HIK} />}>
              <Route path="hik" element={<HIK />} />
            </Route>
            <Route element={<PrivatesRoutes permission={PERMISSIONS.HIK} />}>
              <Route path="camera-monitor" element={<CameraMonitor />} />
            </Route>
          </>
        ) : (
          ""
        )}

        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.VIEW_ACCESS_RIGHTS} />
          }
        >
          <Route path="access" element={<AccessRights />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.VIEW_LIST_READERS} />
          }
        >
          <Route path="readers" element={<ReadersList />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.EDIT_READER} />}
        >
          <Route path="readers/edit/:id" element={<EditReader />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.EDIT_TICKET} />}
        >
          <Route path="ticket/edit/:ticket_id" element={<EditTicket />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.EDIT_SETTINGS} />}
        >
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.VIEW_UPDATE_DATABASE} />
          }
        >
          <Route path="update-database" element={<UpdateDatabase />} />
        </Route>
        <Route>
          <Route path="change-password" element={<ChangePassword />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_PRICELIST} />}
        >
          <Route path="price-list" element={<PriceList />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.EDIT_PRICELIST} />}
        >
          <Route path="price-list/edit/:item_id" element={<EditItem />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_ITEM} />}
        >
          <Route path="new-item" element={<NewItem />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_KIND} />}
        >
          <Route path="add-kind" element={<NewKind />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_CATEGORY} />
          }
        >
          <Route path="add-category" element={<NewCategory />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.CREATE_NEW_TYPE} />}
        >
          <Route path="add-type" element={<NewType />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.VIEW_SEARCH_USERS} />
          }
        >
          <Route path="search-users" element={<SearchUsers />} />
        </Route>

        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.VIEW_PURCHASING} />}
        >
          <Route path="purchasing" element={<Purchasing />} />
        </Route>

        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.TICKET_DESIGN} />}
        >
          <Route path="ticket-design" element={<TicketDesign />} />
        </Route>

        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.TICKET_DESIGN} />}
        >
          <Route path="refund" element={<Refund />} />
        </Route>

        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.TICKET_DESIGN} />}
        >
          <Route
            path="fiscalization-reports"
            element={<FiscalizationReports />}
          />
        </Route>

        <Route element={<PrivatesRoutes permission={PERMISSIONS.VIEW_LOGS} />}>
          <Route path="logs" element={<Logs />} />
        </Route>

        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.NEW_EMPLOYEE} />}
        >
          <Route path="new-employee" element={<NewEmployee />}></Route>
        </Route>

        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.NEW_EMPLOYEE} />}
        >
          <Route path="employees" element={<Employees />}></Route>
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.NEW_EMPLOYEE} />}
        >
          <Route path="employees/edit/:id" element={<EditEmployee />} />
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.ORGANIZATION_UNITS} />
          }
        >
          <Route
            path="new-organization-unit"
            element={<NewOrganizationUnit />}
          ></Route>
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.ORGANIZATION_UNITS} />
          }
        >
          <Route
            path="organization-units"
            element={<OrganizationUnits />}
          ></Route>
        </Route>
        <Route
          element={
            <PrivatesRoutes permission={PERMISSIONS.ORGANIZATION_UNITS} />
          }
        >
          <Route
            path="organization-units/edit/:id"
            element={<EditOrganizationalUnit />}
          />
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.ARTICLE} />}>
          <Route path="new-article" element={<NewArticle />}></Route>
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.ARTICLE} />}>
          <Route path="articles" element={<Articles />}></Route>
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.ARTICLE} />}>
          <Route path="articles/edit/:id" element={<EditArticle />} />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.UNIT_OF_MEASURE} />}
        >
          <Route
            path="new-unit-of-measure"
            element={<NewUnitOfMeasure />}
          ></Route>
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.UNIT_OF_MEASURE} />}
        >
          <Route path="units-of-measure" element={<UnitsOfMeasure />}></Route>
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.UNIT_OF_MEASURE} />}
        >
          <Route
            path="units-of-measure/edit/:id"
            element={<EditUnitOfMeasure />}
          />
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.INGREDIENTS} />}
        >
          <Route path="new-ingredient" element={<NewIngredient />}></Route>
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.INGREDIENTS} />}
        >
          <Route path="ingredients" element={<Ingredients />}></Route>
        </Route>
        <Route
          element={<PrivatesRoutes permission={PERMISSIONS.INGREDIENTS} />}
        >
          <Route path="ingredients/edit/:id" element={<EditIngredient />} />
        </Route>
        <Route element={<PrivatesRoutes permission={PERMISSIONS.ARTICLE} />}>
          <Route path="canteen_reports" element={<DailyArticles />}></Route>
        </Route>

        <Route path="locker-arangment" element={<LockerArangment />}></Route>
        <Route path="lockers" element={<Lockers />}></Route>
        <Route
          path="lockers-monitoring"
          element={<LockersMonitoring />}
        ></Route>
      </Route>
    </Routes>
  );
}
const PerTicketNumberWrapper = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const ticket_id = searchParams.get("ticket_id");
  console.log(ticket_id);
  return <PerTicketNumber ticket_id={ticket_id} />;
};

export default App;
